import { CategoryDetailQuery } from "~/lib/graphql/client";

type Category = CategoryDetailQuery["category"];

type Props = {
  category: Category;
  pageTab: PageTab | null;
};

const PAGE_TABS = ["QUEST", "DATABASE", "LIMITED"] as const;
type PageTab = (typeof PAGE_TABS)[number];

function isPageTab(value: string): value is PageTab {
  return (PAGE_TABS as ReadonlyArray<string>).includes(value);
}

export type { Category, Props, PageTab };

export { isPageTab, PAGE_TABS };
